import { render } from "./SearchDetail.vue?vue&type=template&id=e4b49538&scoped=true"
import script from "./SearchDetail.vue?vue&type=script&lang=js"
export * from "./SearchDetail.vue?vue&type=script&lang=js"

import "./SearchDetail.vue?vue&type=style&index=0&id=e4b49538&lang=scss&scoped=true"

import exportComponent from "D:\\digitalnewspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b49538"]])

export default __exports__